module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "split-view hello"
  }, [_c('div', {
    staticClass: "split-view-top"
  }, [_c('transition-group', {
    directives: [{
      name: "chat-scroll",
      rawName: "v-chat-scroll"
    }, {
      name: "prevent-parent-scroll",
      rawName: "v-prevent-parent-scroll"
    }],
    ref: "conversation",
    staticClass: "conversation",
    attrs: {
      "name": "message",
      "tag": "div"
    }
  }, [_c('message', {
    key: 'welcome',
    attrs: {
      "message": _vm.welcome
    }
  }), _vm._l((_vm.conversation), function(message, index) {
    return _c('message', {
      key: message._id,
      attrs: {
        "message": message
      }
    })
  })], 2)], 1), _c('div', {
    staticClass: "split-view-bottom"
  }, [_c('footer', [_c('loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _c('transition', {
    attrs: {
      "name": "form",
      "mode": "out-in"
    }
  }, [(_vm.chatEnabled || _vm.candidate._id) ? _c('div', {
    staticClass: "form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitMessage($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.body),
      expression: "message.body"
    }, {
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.message.body),
      expression: "message.body"
    }],
    ref: "message",
    attrs: {
      "placeholder": "Write a reply..."
    },
    domProps: {
      "value": (_vm.message.body)
    },
    on: {
      "keydown": _vm.checkSubmit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "body", $event.target.value)
      }
    }
  }), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "send-message",
    attrs: {
      "disabled": _vm.sendingMessage
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  })])])])]), _c('div', {
    staticClass: "powered-by"
  }, [_c('span', [_vm._v("Powered by")]), (_vm.isPF) ? _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.peoplefluent.com/",
      "target": "_blank"
    }
  }, [_vm._v("PeopleFluent")]) : _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://breezy.hr/",
      "target": "_blank"
    }
  }, [_vm._v("breezy")])])]) : _c('div', {
    staticClass: "form"
  }, [(_vm.postingCandidateError) ? _c('div', [_c('p', [_vm._v("There was an error. Try again.")])]) : _vm._e(), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitCandidate($event)
      }
    }
  }, [_c('div', {
    staticClass: "field name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.candidate.name),
      expression: "candidate.name"
    }],
    class: {
      error: _vm.errors.invalid.name
    },
    attrs: {
      "id": "candidateName",
      "type": "text",
      "placeholder": "What's your name?"
    },
    domProps: {
      "value": (_vm.candidate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.candidate, "name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "field email-resume"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.candidate.email_address),
      expression: "candidate.email_address"
    }],
    class: {
      error: _vm.errors.invalid.email_address
    },
    attrs: {
      "type": "email",
      "placeholder": "What's your email address?"
    },
    domProps: {
      "value": (_vm.candidate.email_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.candidate, "email_address", $event.target.value)
      }
    }
  })]), (_vm.messenger.gdprEnabled) ? _c('div', {
    staticClass: "field gdpr"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.candidate.gdpr.consent),
      expression: "candidate.gdpr.consent"
    }],
    class: {
      error: _vm.errors.invalid.consent
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.candidate.gdpr.consent) ? _vm._i(_vm.candidate.gdpr.consent, null) > -1 : (_vm.candidate.gdpr.consent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.candidate.gdpr.consent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.candidate.gdpr, "consent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.candidate.gdpr, "consent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.candidate.gdpr, "consent", $$c)
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.messenger.templates.gdpr.body) + "  ")])]), _c('a', {
    attrs: {
      "href": _vm.privacyLink,
      "target": "_blank"
    }
  }, [_vm._v("View Privacy Notice")])]) : _vm._e(), _c('div', {
    staticClass: "actions clearfix"
  }, [_c('div', {
    staticClass: "button-group-left"
  }, [_c('button', {
    staticClass: "button-link resume",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$upload.select('resume')
      }
    }
  }, [(_vm.$upload.meta('resume').status === 'ready') ? _c('div', [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _c('span', [_vm._v("Upload Resume")])]) : _vm._e(), (_vm.$upload.meta('resume').status === 'sending') ? _c('div', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }), _c('span', [_vm._v("Uploading...")])]) : _vm._e(), (_vm.$upload.meta('resume').status === 'complete') ? _c('div', [_c('i', {
    staticClass: "fa fa-file"
  }), _c('span', [_vm._v(_vm._s(_vm.candidate.resume.file_name))])]) : _vm._e()])]), _c('div', {
    staticClass: "button-group-right"
  }, [_c('button', {
    staticClass: "submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.postingCandidate
    }
  }, [(_vm.postingCandidate) ? _c('div', {
    staticClass: "sending"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Sending...")]), _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  })]) : _c('div', {
    staticClass: "not-sending"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Save & Send")]), _c('i', {
    staticClass: "fa fa-paper-plane"
  })])])])])])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c7b5c51","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Hello.vue
// module id = 124
// module chunks = 1